import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { ChevronRightIcon, CarIcon, CheckIcon } from '@repo/icons';
import classNames from 'classnames';
import VehicleNameDisplay from './VehicleNameDisplay';
import VehicleRegistrationDisplay from './VehicleRegistrationDisplay';
const containerStyles = {
    base: 'flex flex-row cursor-pointer items-center gap-2.5 rounded-xl border px-4 py-5 transition-colors text-left',
    interactive: 'hover:bg-secondary',
    default: 'bg-primary-soft border-stroke-base',
    selected: 'bg-secondary-medium border-fg-success/70',
};
export default function VehicleSelectionCard({ isSelected = false, onClick, testId, vehicle, className = '' }) {
    const handleClick = () => {
        if (onClick) {
            onClick(vehicle);
        }
    };
    const containerClasses = classNames(containerStyles.base, containerStyles.interactive, isSelected ? containerStyles.selected : containerStyles.default, className);
    return (_jsxs("button", { className: containerClasses, onClick: handleClick, "data-testid": testId, children: [_jsx("div", { className: "bg-tertiary flex h-11 w-11 min-w-11 items-center justify-center rounded-lg", children: _jsx(CarIcon, { size: 20, color: "text-body" }) }), _jsxs("div", { className: "flex w-full flex-col gap-2", children: [_jsx(VehicleRegistrationDisplay, { testId: testId.append('registrationNumber'), registrationNumber: vehicle.registrationNumber }), _jsx(VehicleNameDisplay, { testId: testId.append('name'), vehicle: vehicle })] }), isSelected ? _jsx(CheckIcon, { color: "text-fg-success", size: 20 }) : _jsx(ChevronRightIcon, { color: "text-body", size: 20 })] }));
}
